<template>
	<div class="formtracker">
		<div class="page-title">
			<div class="title">
				<h1>Captura de Formulários</h1>
				<p>Capture leads em formulários dos seus sites.</p>
			</div>

			<div v-if="total" class="flex">
				<ui-search-box event="formtracker-search" />
			</div>

			<div class="flex">
				<a href="#" class="button-link" @click="openModal('instructions-api')">
					<i class="fal fa-laptop-code"></i> API para desenvolvedores
				</a>

				<ui-button v-if="total" type="submit" design="md primary" @click="openModal('instructions')">
					Instalar em meu site <i class="fal fa-cog"></i>
				</ui-button>
			</div>
		</div>

		<div class="page" v-if="!total">
			<ui-page-message :text="text"
				:action="go"
				:btnText="btnText"
				:btnIcon="btnIcon"
				icon="fal fa-money-check" />
		</div>

		<div class="page" v-if="total">
			<ui-data-table :columns="tableColumns"
				:sort-by="{ value: 'status', dir: 'asc' }"
                :control-fixed="true"
                :borders="true"
				name="formtracker"
				service="formTracker"
				search-event="formtracker-search"
				tr-component="form-tracker/table-line"
				notFoundIcon="fal fa-money-check"
				notFoundText="Não existe nenhum formulário configurado" />
		</div>

		<ui-sidebar />
		<ui-modal-instructions />
		<ui-modal-instructions-api />
		<ui-modal-message
			service="formTracker"
			name="delete-form"
			title="Deseja realmente excluir?"
			text="Cuidado, esta ação não poderá ser desfeita."
			btn-type="danger"
			btn-text="Confirmar" />
	</div>
</template>

<script>
	import helpers from '@/mixins/helpers'
	import { uiButton } from '@/components/ui/buttons'
	import { uiDataTable, uiPageMessage, uiSearchBox, uiMenuCard } from '@/components/ui'
	import { uiModalMessage } from '@/components/ui/modal'
	import uiSidebar from './components/sidebar'
	import uiModalInstructions from './components/modal-instructions'
	import uiModalInstructionsApi from './components/modal-instructions-api'

	import { formTracker } from '@/services/axios'

	export default {
		mixins: [helpers],
		components: {
			uiButton,
			uiDataTable,
			uiPageMessage,
			uiSearchBox,
			uiSidebar,
			uiMenuCard,
			uiModalInstructions,
			uiModalMessage,
			uiModalInstructionsApi,
		},

		data() {
			return {
				total: 0,
				load: false,
				tableColumns: [
					{
						title: 'Nome',
						size: '',
						data: 'form',
						sortable: true
					},
					{
						title: 'Form ID',
						size: '',
						class: 'h-xs',
					},
					{
						title: 'Status',
						size: '',
						data: 'status',
						sortable: true
					},
					{
						title: 'Leads Capturados',
						size: '',
						class: 'h-xs',
						data: 'leads_total',
						sortable: true
					},
					{
						title: 'Último Processamento',
						size: '',
						class: 'h-xs',
						data: 'updated_at',
						sortable: true
					},
					{
						title: 'Criado Em',
						size: '',
						class: 'h-xs',
						data: 'created_at',
						sortable: true
					},
					{
						title: '',
						size: '40',
					},
				],
				text: '<p>Inclua o script em seu site através de nosso plugin oficial para <strong>WordPress</strong> ou <strong>Código de Incorporação</strong>.</p> <p>Ao incluir o script em seu site o Facilita ficará vigiando todos seus formulários. Quando uma nova submissão é feita, o formulário é detectado e você poderá configurá-lo e ativá-lo de acordo com sua necessidade.</p>',
				btnText: 'Instalar no meu site',
				btnIcon: 'fal fa-cog',
			}
		},

		methods: {
			loadData() {
				this.load = true
				formTracker
					.dataTable()
					.then((response) => {
						this.load = false
						this.total = response.data.data.length
					})
					.catch((error) => {
						this.load = false
						this.total = 0
						console.log(error)
					})
			},
			go() {
				this.openModal('instructions')
			},
			openModal(name) {
				this.$root.$emit('modal-open-' + name)
			},
			closeModal() {
				this.$root.$emit('modal-close-' + name)
			},
		},

		created() {
			this.loadData()
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
